module.exports = __webpack_public_path__ + "img/prayer-journal_B095L3L51W.d144ff41.jpg";